class Timeline {
    constructor($el) {
        this.$el = $el;

        if(this.$el.length) {
            this._init();
            this._onResize();
            this._onScroll();
            this._bindEvents();
        }
    }

    _init() {
        this.$header = $('body').find('.site-header__container');
        this.$timelineSummary = this.$el.find('.timeline__summary');
        this.$timelineSummaryDates = this.$el.find('.timeline__summary-date');
        this.$timelineParts = this.$el.find('.timeline__part');

        this.isSticky = false;
        this.isTicking = false;
        this.stickyOffset = 124;
        this.previousY = 0;
        this.previousRatio = 0;
        this.lastScrollPosition = window.pageYOffset;
        this.updateFn = this._update.bind(this);

        if(this.$timelineParts.length) {
            // this.inScreenObserver = new IntersectionObserver(this._onEnterInScreen.bind(this), {
            //     root: null,
            //     rootMargin: '0px',
            //     threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1]
            // });
            // this.outOfScreenObserver = new IntersectionObserver(this._onLeaveScreen.bind(this), {
            //     root: null,
            //     rootMargin: '0px',
            //     threshold: [0]
            // });

            // this.$timelineParts.each((index, element) => {
            //     this.inScreenObserver.observe(element);
            //     // this.outOfScreenObserver.observe(element);
            // });
        }
    }

    _bindEvents() {
        this.onScrollFn = this._onScroll.bind(this);
        this.onResizeFn = this._onResize.bind(this);
        this.onSummaryDateClickFn = this._onSummaryDateClick.bind(this);

        this.$timelineSummaryDates.on('click', this.onSummaryDateClickFn);
        window.addEventListener('scroll', this.onScrollFn);
        window.addEventListener('resize', this.onResizeFn);
    }

    _onSummaryDateClick(e) {
        e.preventDefault();

        const $target = $(e.target);
        const id = $target.attr('data-target-id');

        // this.$timelineSummaryDates.removeClass('timeline__summary-date--current');
        // $target.addClass('timeline__summary-date--current');

        $('html, body').animate({scrollTop: Math.max($('#' + id).offset().top - 80, 0)}, 450);
    }

    // _onEnterInScreen(entries, observer) {
    //     entries.forEach(entry => {
    //         const id = entry.target.getAttribute('id');
    //         const currentY = entry.boundingClientRect.y;
    //         const currentRatio = entry.intersectionRatio;
    //         const isIntersecting = entry.isIntersecting;
    //         console.log('entry', entry);

    //         if(typeof entry.target.previousY === 'undefined') {
    //             entry.target.previousY = 0;
    //         }
    //         if(typeof entry.target.previousRatio === 'undefined') {
    //             entry.target.previousRatio = 0;
    //         }

    //         if(currentY < entry.target.previousY) {
    //             if(currentRatio > entry.target.previousRatio && isIntersecting) {
    //                 if(currentRatio > 0.5) {
    //                     console.log(id + " Scrolling down enter");
    //                     this.$timelineSummaryDates.filter('[data-target-id="' + id + '"]').addClass('timeline__summary-date--current');
    //                 }
    //             }
    //             else {
    //                 if(currentRatio < 0.5) {
    //                     console.log(id + " Scrolling down leave");
    //                     this.$timelineSummaryDates.filter('[data-target-id="' + id + '"]').removeClass('timeline__summary-date--current');
    //                 }
    //             }
    //         }
    //         else if(currentY > entry.target.previousY && isIntersecting) {
    //             if(currentRatio < entry.target.previousRatio) {
    //                 if(currentRatio < 0.5) {
    //                     console.log(id + " Scrolling up leave");
    //                     this.$timelineSummaryDates.filter('[data-target-id="' + id + '"]').removeClass('timeline__summary-date--current');
    //                 }
    //             }
    //             else {
    //                 if(currentRatio > 0.5) {
    //                     console.log(id + " Scrolling up enter");
    //                     this.$timelineSummaryDates.filter('[data-target-id="' + id + '"]').addClass('timeline__summary-date--current');
    //                 }
    //             }
    //         }

    //         entry.target.previousY = currentY
    //         entry.target.previousRatio = currentRatio

    //         // if(entry.isIntersecting && entry.intersectionRatio >= 0.3 && entry.intersectionRatio <= 1) {
    //         // console.log('OnEnter: ',entry.intersectionRect, entry.intersectionRatio, id);

    //         //     this.$timelineSummaryDates.removeClass('timeline__summary-date--current');
    //         //     this.$timelineSummaryDates.filter('[data-target-id="' + id + '"]').addClass('timeline__summary-date--current');
    //         // }
    //     });
    // }

    // _onLeaveScreen(entries, observer) {
    //     entries.forEach(entry => {
    //         const id = entry.target.getAttribute('id');

    //         if(entry.intersectionRatio == 0) {
    //             console.log('OnLeave: ', id, entry.intersectionRatio);
    //             this.$timelineSummaryDates.filter('[data-target-id="' + id + '"]').removeClass('timeline__summary-date--current');
    //         }

    //     });
    // }

    _onScroll() {
        this.lastScrollPosition = window.pageYOffset;

        if(!this.isTicking) {
            this.isTicking = true;

            window.requestAnimationFrame(this.updateFn);
        }
    }

    _onResize() {
        const wW = window.innerWidth;

        if(wW < 768) {
            this.stickyOffset = 124;
        }
        else if(wW >= 768) {
            this.stickyOffset = 112;
        }
        else if(wW >= 992) {
            this.stickyOffset = 160;
        }
    }

    _update() {
        this.isTicking = false;

        if(!this.isSticky && this.lastScrollPosition >= this.stickyOffset) {
            this.$timelineSummary[0].classList.add('timeline__summary--sticky');
            this.isSticky = true;
        }
        else if(this.isSticky && this.lastScrollPosition < this.stickyOffset) {
            this.$timelineSummary[0].classList.remove('timeline__summary--sticky');
            this.isSticky = false;
        }

        this.$timelineParts.each((index, element) => {
            const boundingRect = element.getBoundingClientRect();
            if((boundingRect.top + this.lastScrollPosition) - window.innerHeight / 2 < this.lastScrollPosition) {
                this.$timelineSummaryDates.removeClass('timeline__summary-date--current');
                this.$timelineSummaryDates.eq(index).addClass('timeline__summary-date--current');
            }
        });
    }
}

export default Timeline;
